<template>
    <el-button type="text" :loading="loading" @click="handleClick">
        <i :class="iconClass"></i>
        {{buttonText}}
    </el-button>
</template>

<script>
export default {
  name: "RtButton",
  props: {
    type: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    text: {
      type: String
    }
  },
  data() {
    return {
      iconClass: null,
      buttonText: null
    };
  },
  created() {
    this.iconClass = "rt-icon-" + this.type;
    switch (this.type) {
      case "add":
        this.buttonText = this.text || "新建";
        break;
      case "print":
        this.buttonText = this.text || "打印";
        break;
      case "confirm":
        this.buttonText = this.text || "确认";
        break;
      case "approve-progress":
        this.buttonText = this.text || "审批进度";
        break;
      case "delete":
        this.buttonText = this.text || "删除";
        break;
      case "enable":
        this.buttonText = this.text || "启用";
        break;
      case "disable":
        this.buttonText = this.text || "停用";
        break;
      case "more":
        this.buttonText = this.text || "更多";
        break;
      case "export":
        this.buttonText = this.text || "导出";
        break;
      case "import":
        this.buttonText = this.text || "导入";
        break;
      case "submit":
        this.buttonText = this.text || "提交";
        break;
      case "revert":
        this.buttonText = this.text || "撤回";
        break;
      case "download":
        this.buttonText = this.text || "下载";
        break;
      case "save":
        this.buttonText = this.text || "保存";
        break;
      default:
        this.iconClass = "";
        this.buttonText = this.text || "<Text>";
        break;
    }
  },
  methods: {
    handleClick() {
      this.$emit("click");
    }
  }
};
</script>


// WEBPACK FOOTER //
// main.vue?ddcc8ae8